import { render, staticRenderFns } from "./CreateBulk.vue?vue&type=template&id=0e115d93&"
import script from "./CreateBulk.vue?vue&type=script&lang=js&"
export * from "./CreateBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports